import React from "react";

interface Props {
  className?: string;
  width?: string;
}

export const Logo: React.FC<Props> = ({ className, width }) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "109.965"}
        height={!width ? "25.568" : undefined}
        viewBox="0 0 109.965 25.568"
      >
        <g
          id="Group_268"
          data-name="Group 268"
          transform="translate(-84.513 288.349)"
        >
          <g
            id="Group_264"
            data-name="Group 264"
            transform="translate(109.514 -285.972)"
          >
            <path
              id="Path_55"
              data-name="Path 55"
              d="M153.243-267.026c0,1.709.932,2.641,2.8,2.641,1.709,0,2.641-.932,2.641-2.019,0-2.951-9.63-1.243-9.63-8.233,0-2.951,2.641-5.592,6.99-5.592,4.194,0,6.835,2.641,6.835,6.214l-4.35.31a2.286,2.286,0,0,0-2.485-2.485,2.132,2.132,0,0,0-2.33,1.864c0,2.8,9.631,1.087,9.631,8.233,0,3.107-2.641,5.747-7.3,5.747-4.5,0-7.145-2.641-7.145-6.369Z"
              transform="translate(-148.894 281.006)"
            />
            <path
              id="Path_56"
              data-name="Path 56"
              d="M192.093-266.228h4.194v7.611c0,1.864,1.087,2.951,2.641,2.951s2.641-1.087,2.641-2.951v-7.611h4.194v14.29h-3.107l-.621-1.4a6.763,6.763,0,0,1-4.194,1.553c-3.418,0-5.748-2.33-5.748-6.058Z"
              transform="translate(-175.318 272.442)"
            />
            <path
              id="Path_57"
              data-name="Path 57"
              d="M244.41-261.655a6.094,6.094,0,0,1-4.039,1.553c-3.573,0-6.68-3.107-6.68-7.3s3.107-7.3,6.68-7.3a5.754,5.754,0,0,1,3.573,1.243v-6.369h4.194v19.572h-3.107ZM244.1-267.4a3.2,3.2,0,0,0-3.107-3.418,3.2,3.2,0,0,0-3.107,3.418,3.2,3.2,0,0,0,3.107,3.417A3.2,3.2,0,0,0,244.1-267.4Z"
              transform="translate(-200.763 280.761)"
            />
            <path
              id="Path_58"
              data-name="Path 58"
              d="M284.593-267.029a7.328,7.328,0,0,1,7.3,7.456,7.327,7.327,0,0,1-7.3,7.456,7.327,7.327,0,0,1-7.3-7.456A7.327,7.327,0,0,1,284.593-267.029Zm0,3.884c-1.709,0-3.107,1.4-3.107,3.573s1.4,3.573,3.107,3.573,3.107-1.4,3.107-3.573S286.3-263.145,284.593-263.145Z"
              transform="translate(-227.432 272.932)"
            />
            <path
              id="Path_59"
              data-name="Path 59"
              d="M319.692-255.355l5.9-6.835h-5.9v-4.039h11.339v3.417l-5.9,6.835h6.213v4.039h-11.65Z"
              transform="translate(-253.367 272.442)"
            />
            <path
              id="Path_60"
              data-name="Path 60"
              d="M358.022-282.229a2.389,2.389,0,0,1,2.33,2.33,2.389,2.389,0,0,1-2.33,2.33,2.389,2.389,0,0,1-2.33-2.33A2.389,2.389,0,0,1,358.022-282.229Zm-2.175,6.214h4.194v14.29h-4.194Z"
              transform="translate(-275.387 282.229)"
            />
          </g>
          <g
            id="Group_267"
            data-name="Group 267"
            transform="translate(84.513 -288.349)"
          >
            <g
              id="Group_265"
              data-name="Group 265"
              transform="translate(0 12.389)"
            >
              <path
                id="Path_61"
                data-name="Path 61"
                d="M92.063-243.267c-4.985,0-7.4-2.419-7.54-4.667-.105-1.726.612-4.622,6.595-4.622.137,0,.41,0,.41,0a4.78,4.78,0,0,0,3.782-1.985,4.58,4.58,0,0,1,3.909-1.909c5.382,0,3.89,7.64.271,10.675A11.68,11.68,0,0,1,92.063-243.267Z"
                transform="translate(-84.513 256.446)"
                fill="#66dd98"
              />
            </g>
            <g
              id="Group_266"
              data-name="Group 266"
              transform="translate(1.923)"
            >
              <path
                id="Path_62"
                data-name="Path 62"
                d="M100.148-288.349c4.985,0,7.4,2.419,7.54,4.667.106,1.726-.611,4.622-6.595,4.622-.137,0-.41,0-.41,0a4.779,4.779,0,0,0-3.782,1.985,4.581,4.581,0,0,1-3.909,1.909c-5.382,0-3.89-7.64-.271-10.675A11.677,11.677,0,0,1,100.148-288.349Z"
                transform="translate(-89.466 288.349)"
                fill="#66dd98"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
